
import { CMS_PAGE, FAQ_GET, FAQ_GET_APP } from "../Constants/CmsPageConstants";
import { createGetDataReducer } from "./CommonReducer";

const CmsPageReducer = createGetDataReducer(CMS_PAGE);
const FaqGetReducer = createGetDataReducer(FAQ_GET);
const FaqGetAppReducer = createGetDataReducer(FAQ_GET_APP);


export const CmsReducers = {
    CmsPageState: CmsPageReducer,
    FaqGetState: FaqGetReducer,
    FaqGetAppState: FaqGetAppReducer
}